import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { ConfirmService }                   from '../messages/confirm/confirm.service';
import { MessagesService }                  from '../messages/messages.service';
import { VehiclesAdvertisingChannelModel }  from './typings/vehicles.advertising-channel';
import { VehiclesAdvertisingDetailsModel }  from './typings/vehicles.advertising-details';
import { VehiclesAdvertisingModel }         from './typings/vehicles.advertising';
import { VehiclesAdvertisingSettingsModel } from './typings/vehicles.advertising-settings';
import { VehiclesService }                  from './vehicles.service';

@Component({
  selector   : 'wor-vehicle-advertising',
  template: require('./vehicle.advertising.component.html')
})
export class VehicleAdvertisingComponent {
  @Input() advertising: VehiclesAdvertisingModel         = {} as VehiclesAdvertisingModel;
  @Input() settings   : VehiclesAdvertisingSettingsModel = {} as VehiclesAdvertisingSettingsModel;

  // One row per advertising site, in the order the page has always listed them.
  channels : Array<VehiclesAdvertisingChannelModel> = [
    {
      image  : 'carsales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.CAR_SALES',
      model  : 'car_sales_aus',
      name   : 'car_sales',
      setting: 'has_car_sales',
      site   : 'carsales.com.au',
      type   : 'carsales'
    },
    {
      image  : 'bikesales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.BIKE_SALES',
      model  : 'bike_sales_aus',
      name   : 'bike_sales',
      setting: 'has_bike_sales',
      site   : 'bikesales.com.au',
      type   : 'bikesales'
    },
    {
      image  : 'boatsales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.BOAT_SALES',
      model  : 'boat_sales_aus',
      name   : 'boat_sales',
      setting: 'has_boat_sales',
      site   : 'boatsales.com.au',
      type   : 'boatsales'
    },
    {
      image  : 'trucksales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.TRUCK_SALES',
      model  : 'truck_sales_aus',
      name   : 'truck_sales',
      setting: 'has_truck_sales',
      site   : 'trucksales.com.au',
      type   : 'trucksales'
    },
    {
      image  : 'constructionsales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.CONSTRUCTION_SALES',
      model  : 'construction_sales_aus',
      name   : 'construction_sales',
      setting: 'has_construction_sales',
      site   : 'constructionsales.com.au',
      type   : 'constructionsales'
    },
    {
      image  : 'farmmachinerysales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.FARM_MACHINERY_SALES',
      model  : 'farm_machinery_sales_aus',
      name   : 'farm_machinery_sales',
      setting: 'has_farm_machinery_sales',
      site   : 'farmmachinerysales.com.au',
      type   : 'farmmachinerysales'
    },
    {
      image  : 'caravancampingsales.png',
      label  : 'DEALERSHIP_SPACE.ADVERTISING.CARAVAN_CAMPING_SALES',
      model  : 'caravan_camping_sales_aus',
      name   : 'caravan_camping_sales',
      setting: 'has_caravan_camping_sales',
      site   : 'caravancampingsales.com.au',
      type   : 'caravancampingsales'
    }
  ];

  collapsed = false;

  constructor (
    private confirmService  : ConfirmService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService,
    private vehiclesService : VehiclesService
  ) {}

  save ( channel : VehiclesAdvertisingChannelModel, isEnabled : boolean ) : void {
    const label = this.translateService.instant(channel.label);

    this.vehiclesService.saveAdvertising(this.advertising)
      .then(() => {
        this.router.stateService.reload();

        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

        const details : VehiclesAdvertisingDetailsModel = {
          advertising     : this.advertising,
          advertising_type: channel.type
        };

        return this.confirmService.generic(this.translateService.instant(isEnabled
            ? 'JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_ON'
            : 'JS_SPACE.CONFIRM.CAR_SALES_ADVERTISING_OFF', {
                name: label
              }))
          .then(() => isEnabled
            ? this.vehiclesService.addAttachmentAdvertising(details)
            : this.vehiclesService.removeAttachmentAdvertising(details))
          .then(( result : boolean ) => {
            if ( result ) {
              this.router.stateService.reload();

              this.messagesService.show(this.translateService.instant(isEnabled
                ? 'JS_SPACE.MESSAGES.ADVERTISING_ON_FOR_ALL_IMAGES'
                : 'JS_SPACE.MESSAGES.ADVERTISING_OFF_FOR_ALL_IMAGES', {
                    name: label
                  }), 'success');
            }
          });
      })
      .catch(error => this.messagesService.error(error));
  }
}
